import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { ContractDetailsRestService } from 'app/core/services/rest/contract-details.rest.service';
import { Observable, ReplaySubject } from 'rxjs';
import { Directive, Input } from '@angular/core';
import { CDLineItemValidation } from 'app/core/store/contract-details/contract-details.interface';

@Directive({
  selector: '[lineRefValidator]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: LineRefValidator,
      multi: true,
    },
  ],
})
export class LineRefValidator implements AsyncValidator {
  @Input() lineItem: CDLineItemValidation;

  constructor(private contractDetailsRestService: ContractDetailsRestService) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const subject = new ReplaySubject<null | { success: boolean; message: string }>();

    if (control.value && control.value !== '') {
      this.contractDetailsRestService
        .validateLineRef({
          lineReferenceId: control.value,
          mask: this.lineItem.mask,
          referenceRequired: this.lineItem.reference,
        })
        .subscribe(result => {
          if (result.success) {
            subject.next(null);
            subject.complete();
          } else {
            subject.next({
              success: result.success,
              message: result.message,
            });
            subject.complete();
          }
        });
    } else {
      subject.next(null);
      subject.complete();
    }
    return subject;
  }
}
